module.exports = __webpack_public_path__ + "media/assets/Maximize-ccfb31db625c27c229c8753e843d4577.svg";